<template>
    <mdb-container>
        <mdb-card cascade class="cascading-admin-card">
            <!--Card Data-->
            <div class="admin-up">
                <mdb-icon icon="stopwatch" class="secondary-color"></mdb-icon>
                <div class="data">
                    <p>MINUTES VISIONNÉES</p>
                    <mdb-spinner small color="blue" v-if="nbtoday===0" />
                    <h4 class="font-weight-bold dark-grey-text" v-else>{{nbtoday}} minutes</h4>
                </div>
            </div>
            <!--/.Card Data-->

            <!--Card content-->
            <mdb-card-body cascade>
                <mdb-card-text>Hier: {{nbyesterday}} minutes</mdb-card-text>
            </mdb-card-body>
            <!--/.Card content-->
        </mdb-card>
    </mdb-container>
</template>

<script>
    import {
        mdbCard,
        mdbIcon,
        mdbCardBody,
        mdbContainer,
        mdbSpinner,
        mdbCardText,
    } from 'mdbvue';
    import Apicall from '../libs/Apicall';

    export default {
        name: 'nbviewedminutescard',
        components: {
            mdbCard,
            mdbIcon,
            mdbCardBody,
            mdbContainer,
            mdbSpinner,
            mdbCardText,
        },
        data() {
            return {
                nbtoday: 0,
                nbyesterday: 0,
            };
        },
        mounted() {
            this.getAndDisplayFormations();
        },
        methods: {
            getAndDisplayFormations() {
                const api = new Apicall();
                const self = this;
                api.getNbMinutesViewed().then((response) => {
                    if (response.status === 'OK') {
                        self.nbtoday = response.nbtoday;
                        self.nbyesterday = response.nbyesterday;
                    }
                });
            },
        },
    };
</script>

<style scoped>
    .cascading-admin-card {
        margin-top: 20px; }
    .cascading-admin-card .admin-up {
        margin-left: 4%;
        margin-right: 4%;
        margin-top: -20px; }
    .cascading-admin-card .admin-up .fas, .cascading-admin-card .admin-up .far, .cascading-admin-card .admin-up .fab {
        padding: 1.7rem;
        font-size: 2rem;
        color: #fff;
        text-align: left;
        -webkit-border-radius: 3px;
        border-radius: 3px; }
    .cascading-admin-card .admin-up .data {
        float: right;
        margin-top: 2rem;
        text-align: right; }
    .cascading-admin-card .admin-up .data p {
        color: #999999;
        font-size: 12px;
    }
</style>
